import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import axiosClient from '~/api/axiosClient'
import { EFButton, EFTypography } from '~/components'
import { ALL_NS } from '~/i18n/namespaces'

const NotFound = () => {
  const { t } = useTranslation(ALL_NS)
  const navigate = useNavigate()

  useQuery([], () => axiosClient.get(window.location.pathname))

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '50vh'
      }}
    >
      <EFTypography
        variant='h1'
        fontWeight='600'
        fontSize='4rem !important'
        color='warning'
      >
        404
      </EFTypography>
      <EFTypography
        variant='h6'
        fontSize='1.3rem !important'
        color='warning'
      >
        {t('Message_PageNotExist')}
      </EFTypography>
      <EFButton
        onClick={() => navigate('/')}
        sx={{ height: '3rem !important', marginTop: '1rem' }}
        variant='contained'
      >
        {t('Button_BackHome')}
      </EFButton>
    </Box>
  )
}

export default NotFound
